module.exports = __webpack_public_path__ + "static/media/Triangle Prism.33b2e2df.jpg";